import { useEffect, useRef } from 'react'

export const useUserInteraction = (
  callback: () => void,
  enable = true,
  maxIdleTime = 15 * 60 * 1000,
) => {
  const timeoutId = useRef<NodeJS.Timeout>()
  const eventTypes = ['mousemove', 'keydown', 'touchstart', 'pointerdown']

  const eventHandler = () => {
    clearTimeout(timeoutId.current)
    timeoutId.current = setTimeout(callback, maxIdleTime)
  }

  const addEventListeners = () => {
    eventTypes.forEach((type) =>
      window.addEventListener(type as keyof WindowEventMap, eventHandler, {
        passive: true,
        capture: true,
      }),
    )
  }

  const removeEventListeners = () => {
    eventTypes.forEach((type) =>
      window.removeEventListener(type as keyof WindowEventMap, eventHandler, {
        capture: true,
      }),
    )
  }

  useEffect(() => {
    if (!enable) {
      return
    }

    addEventListeners()
    timeoutId.current = setTimeout(callback, maxIdleTime)
    return () => {
      removeEventListeners()
      clearTimeout(timeoutId.current)
    }
  }, [callback, enable, maxIdleTime])
}
